/**
 * @class FilterButtonsMobile
 * @classdesc This class handles the buttons that are used for mobile filtering.
 *
 * @extends Core.Component
 */
export default class FiltersButtonsMobile extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this.mobileFiltersButton = el.querySelector('[data-mobile-filters-button]');
  }

  onMount() {
    this.sortByButton = this.query('disclosure');

    if (this.mobileFiltersButton) {
      this.events.register(this.mobileFiltersButton, 'click', e => {
        e.stopPropagation();
        const openEvent = new CustomEvent('filter:open', { detail: { trigger: this.mobileFiltersButton } });
        this.el.dispatchEvent(openEvent);
      });
    }

    if (this.sortByButton) {
      this.events.register(this.sortByButton.el, 'input', () => {
        const searchParams = new URLSearchParams(window.location.search);
        searchParams.set('sort_by', this.sortByButton.getValue());

        // Fire off event to submit the new params to the parent section
        const updateEvent = new CustomEvent('filter:update', { detail: { searchParams: searchParams.toString() } });
        this.el.dispatchEvent(updateEvent);
      });
    }
  }

  /**
   * This will update the buttons based on the filters being updated asynchronously.
   *
   * @param {HTMLElement} newDom The new elements to update.
   */
  updateFilters(newDom) {
    this.mobileFiltersButton.innerHTML = newDom.querySelector('[data-mobile-filters-button]').innerHTML;

    if (newDom.querySelector('[data-results-count]').dataset.resultsCount === '0') {
      this.el.classList.add('hidden');
    } else {
      this.el.classList.remove('hidden');
    }
  }
}
